import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 保存信息
    userInfo: {},
    // 保存认识手机结尾信息
    phoneInfo: {},
    // 再次体验
    isAgainTitle: {},
    // 页面切换验证
    switchingMsg: '',
    // 标题
    navTitle: '',
    // 返回
    returnParams: {}
  },
  getters: {
    userInfo: state => state.userInfo,
    phoneInfo: state => state.phoneInfo,
    isAgainTitle: state => state.isAgainTitle,
    switchingMsg: state => state.switchingMsg,
    navTitle: state => state.navTitle,
    returnParams: state => state.returnParams
  },
  mutations: {
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    setPhoneInfo (state, phoneInfo) {
      state.phoneInfo = phoneInfo
    },
    setIsAgainTitle (state, isAgainTitle) {
      state.isAgainTitle = isAgainTitle
    },
    // 页面切换
    setSwitchingMsg (state, switchingMsg) {
      state.switchingMsg = switchingMsg
    },
    setNavTitle (state, navTitle) {
      state.navTitle = navTitle
    },

    // 返回
    setReturn (state, payload) {
      state.returnParams = payload
    }

  },
  actions: {
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage // 或者 localStorage
  })],
  modules: {
  }
})
